import React from 'react';
import { RiddleComponent } from '@src/interfaces';
import ParagraphProps from '@src/components/Paragraph/paragraph-props';
import Riddle from '@src/components/Riddle/Riddle';

const RiddleParagraph = (props: ParagraphProps) => {
  const data = props.paragraph.data as Pick<RiddleComponent, 'riddleId' | 'title'>;
  return <Riddle {...data} />;
};

export default RiddleParagraph;
